import { useState } from 'react';
import { googleSignIn } from '../utils/auth';

const RegisterPage = ({ onRegister, onGoogleSuccess, onSwitch, country, onOpenTerms, onOpenPrivacy }) => {
  const [form, setForm] = useState({ firstName:"", lastName:"", email:"", password:"", confirmPassword:"" });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!form.firstName.trim()) e.firstName = "Required";
    if (!form.lastName.trim()) e.lastName = "Required";
    if (!form.email.trim() || !form.email.includes("@")) e.email = "Valid email required";
    if (form.password.length < 8) e.password = "Min 8 characters";
    if (form.password !== form.confirmPassword) e.confirmPassword = "Passwords don't match";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) onRegister(form);
  };

  const update = (field, val) => {
    setForm(prev => ({...prev, [field]: val}));
    if (errors[field]) setErrors(prev => { const n={...prev}; delete n[field]; return n; });
  };

  return (
    <div className="auth-page">
      <div className="auth-left">
        <h1>Start Investing Today</h1>
        <p>Join thousands of investors building wealth through fractional real estate ownership.</p>
        <ul className="auth-features">
          <li><i className="fas fa-check-circle"></i> Start with as little as $500</li>
          <li><i className="fas fa-check-circle"></i> Access vetted, income-producing properties</li>
          <li><i className="fas fa-check-circle"></i> Earn passive monthly dividends</li>
          <li><i className="fas fa-check-circle"></i> Sell shares anytime for liquidity</li>
        </ul>
      </div>
      <div className="auth-right">
        <div className="auth-card">
          <h2>Create Account</h2>
          <p className="subtitle">Join CoOwn and start building your real estate portfolio</p>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>First Name</label>
                <input placeholder="John" value={form.firstName} onChange={(e)=>update("firstName",e.target.value)} />
                {errors.firstName && <div className="form-error">{errors.firstName}</div>}
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input placeholder="Doe" value={form.lastName} onChange={(e)=>update("lastName",e.target.value)} />
                {errors.lastName && <div className="form-error">{errors.lastName}</div>}
              </div>
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input type="email" placeholder="you@example.com" value={form.email} onChange={(e)=>update("email",e.target.value)} />
              {errors.email && <div className="form-error">{errors.email}</div>}
            </div>
            <div className="form-group">
              <label>Password</label>
              <input type="password" placeholder="Min 8 characters" value={form.password} onChange={(e)=>update("password",e.target.value)} />
              {errors.password && <div className="form-error">{errors.password}</div>}
            </div>
            <div className="form-group">
              <label>Confirm Password</label>
              <input type="password" placeholder="Repeat password" value={form.confirmPassword} onChange={(e)=>update("confirmPassword",e.target.value)} />
              {errors.confirmPassword && <div className="form-error">{errors.confirmPassword}</div>}
            </div>
            <label style={{display:"flex",alignItems:"flex-start",gap:"0.5rem",fontSize:"0.85rem",color:"var(--text-light)",marginBottom:"1rem",cursor:"pointer"}}>
              <input type="checkbox" style={{marginTop:"0.2rem"}} />
              I agree to the{" "}
              <a href="/terms" style={{ color: "var(--primary)" }} onClick={(e) => { e.preventDefault(); onOpenTerms?.(); }}>Terms of Service</a>
              {" "}and <a href="/privacy-policy" style={{ color: "var(--primary)" }} onClick={(e) => { e.preventDefault(); onOpenPrivacy?.(); }}>Privacy Policy</a>
            </label>
            <button type="submit" className="btn btn-primary" style={{width:"100%",padding:"0.9rem"}}>Create Account</button>
          </form>
          <div className="auth-divider">or sign up with</div>
          <button className="social-btn" style={{marginBottom:"0.5rem"}} onClick={() => googleSignIn(onGoogleSuccess, country || "US")}>
            <i className="fab fa-google" style={{color:"#DB4437"}}></i> Continue with Google
          </button>
          <button className="social-btn">
            <i className="fab fa-apple" style={{color:"#000"}}></i> Continue with Apple
          </button>
          <p style={{textAlign:"center",marginTop:"1.5rem",color:"var(--text-light)",fontSize:"0.9rem"}}>
            Already have an account? <a href="#" onClick={(e)=>{e.preventDefault();onSwitch();}} style={{color:"var(--primary)",fontWeight:600,textDecoration:"none"}}>Log in</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
